import { render, staticRenderFns } from "./TVConfigPage.vue?vue&type=template&id=10e67818&scoped=true"
import script from "./TVConfigPage.vue?vue&type=script&lang=js"
export * from "./TVConfigPage.vue?vue&type=script&lang=js"
import style0 from "./TVConfigPage.vue?vue&type=style&index=0&id=10e67818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e67818",
  null
  
)

export default component.exports